import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Subject } from 'rxjs';
import { SessionService } from 'app/store/services/session.service';
import { Router } from '@angular/router';
import { IUserSessionData } from 'app/store/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'app/store/services/user.service';
import { Store } from '@ngrx/store';
import { IReducers } from '../../store/reducers';
import { openSnackbar } from '../../store/actions/page.action';

@Component({
  selector: 'app-prefs-goals',
  templateUrl: './prefs-goals.component.html',
  styleUrls: ['./prefs-goals.component.scss'],
})
export class PrefsGoalsComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;

  cancelButtonProperties: Button = {
    text: 'Cancel',
    color: ButtonColor.RED,
    size: ButtonSize.SMALL,
    route: ['/accounts', 'settings'],
    style: 'outline',
  };

  continueButtonProperties: Button = {
    text: 'Save',
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    onClick: () => this.submitForm(),
    style: 'outline',
  };

  sessionData: IUserSessionData;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private userService: UserService,
    private readonly store$: Store<IReducers>,
  ) {
  }

  submitForm() {
    if (this.formGroup.valid) {
      this.userService
        .updateGoalPreferences(this.sessionData.id, {
          prefered_appointment_goal: this.formGroup.get('pref_appointment_goal')
            .value,
          prefered_average_cycle: this.formGroup.get('pref_avg_cycle').value,
          prefered_average_sale: this.formGroup.get('pref_avg_sale').value,
          prefered_goals_monthly: this.formGroup.get('pref_goals_rep_monthly')
            .value,
          prefered_goals_weekly: this.formGroup.get('pref_goals_rep_weekly')
            .value,
          prefered_sales_goal: this.formGroup.get('pref_sales_goal').value,
        })
        .subscribe(() => {
          this.store$.dispatch(openSnackbar({
            snackbarData: {
              data: {
                message: 'Changes are saved successfully!',
                type: 'success',
              },
            },
          }));
          this.router.navigate(['/']);
        }, err => this.store$.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: err.error,
              type: 'error',
            },
          },
        })));
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(sessionData => {
        this.sessionData = sessionData;

        this.formGroup = new FormGroup({
          pref_avg_sale: new FormControl(
            this.sessionData.prefered_average_sale,
            [Validators.required, Validators.pattern('[0-9]{1,}')],
          ),
          pref_avg_cycle: new FormControl(
            this.sessionData.prefered_average_cycle,
            [Validators.required, Validators.pattern('[0-9]{1,}')],
          ),
          pref_appointment_goal: new FormControl(
            this.sessionData.prefered_appointment_goal,
            [Validators.required, Validators.pattern('[0-9]{1,}')],
          ),
          pref_sales_goal: new FormControl(
            this.sessionData.prefered_sales_goal,
            [Validators.required, Validators.pattern('[0-9]{1,}')],
          ),
          pref_goals_rep_weekly: new FormControl(
            this.sessionData.prefered_goals_weekly,
            [Validators.required, Validators.pattern('[0-9]{1,}')],
          ),
          pref_goals_rep_monthly: new FormControl(
            this.sessionData.prefered_goals_monthly,
            [Validators.required, Validators.pattern('[0-9]{1,}')],
          ),
        });
      });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }
}
